<template>
  <div v-title :data-title="$route.name">
    <div class="flex">
      <el-card style="width: 500px; max-height: 600px">
        <div class="mb_10 flex LH_input font_14 text_bold">
          <span class="mr_5" style="width: 150px">New Type:</span>
          <el-input v-model="Intention"></el-input>
          <el-button type="primary" size="small" @click="AddProType()"
            >Create</el-button
          >
        </div>
        <el-table
          border
          :header-cell-style="{
            background: '#1484D6',
            color: '#fff',
            padding: ' 5px 0',
          }"
          :data="tableData"
          max-height="500px"
        >
          <el-table-column
            align="center"
            label="Enquiry Type"
            prop="IntentionName"
          ></el-table-column>
          <el-table-column label="Action" align="center">
            <template slot-scope="scope">
              <span
                class="underline color_red pointer"
                @click="EditName(scope.row)"
                >Rename</span
              >
              <span
                v-if="scope.row.IsDelete === 0"
                class="underline color_red pointer ml_5"
                @click="VoidName(1, scope.row.IntentionId)"
                >Void</span
              >
              <span
                v-else
                class="underline color_red pointer ml_5"
                @click="VoidName(0, scope.row.IntentionId)"
                >Recover</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
  </div>
</template>

<script>
import { get, post } from "../assets/api/api";
import {
  IntentionAdminList,
  OrdersIntentionList,
  OrdersIntentionRegister,
  DeleteFile,
  ProductAdminUploadFile,
  UpdateIsShow,
  VoidOrdersIntention,
} from "../assets/api/request";

export default {
  data() {
    return {
      Intention: "",
      IntentionId: 0,
      tableData: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 添加修改Intention类型
    AddProType() {
      if (!this.Intention) {
        this.$message.error("Please enter Type Name");
        return;
      }
      this.$confirm("Are you sure to continue?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        let data = {
          IntentionId: this.IntentionId,
          IntentionName: this.Intention,
        };
        post(OrdersIntentionRegister, data).then((res) => {
          if (res.data.code === 200) {
            this.getData();
            this.IntentionId = 0;
            this.$message.success("Successful.");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    getData() {
      get(OrdersIntentionList).then((res) => {
        this.tableData = res.data.data;
      });
    },
    EditName(row) {
      this.IntentionId = row.IntentionId;
      this.Intention = row.IntentionName;
    },
    VoidName(type, id) {
      this.$confirm("Are you sure to continue?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        get(
          VoidOrdersIntention + "?IntentionId=" + id + "&IsDelete=" + type
        ).then((res) => {
          if (res.data.code === 200) {
            this.getData();
            this.$message.success("Successful.");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
  },
};
</script>
<style scoped></style>
